module.exports = __webpack_public_path__ + "media/images/news/200518-5fd9b3b6240f289e8293a3ababd0d588.jpg";